import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { getValidLocaleCode } from "@utils/localisation"

import Layout from "@components/Layout"
import { graphql } from "gatsby"

import ScrapMetalPriceIndex from "@modules/PriceIndexPage/PriceSection"
import MessageBanner from "@components/MessageBanner"
import ListOfCountries from "@modules/PriceIndexPage/ListOfCountries"
import { CategoryPrices } from "@modules/CategoryPrices"
import BreadCrumb from "@components/BreadCrumb"
import FaqSection from "@components/FaqSection"
import CasesCarrouselSection from "@modules/HomePage/CasesCarrouselSection"
import OperationalExcellence from "@modules/Metals/operationalExcellence"
import BuySellBanner from "@components/BuySellBanner"
import MainTitleAndDescription from "@components/MainTitleAndDescription"
import { PriceAlertsBanner } from "@modules/PriceAlertsBanner"

const PriceIndexPage = props => {
  const { i18n, t } = useTranslation()

  const pageContext = props.pageContext
  if (i18n.language !== props.pageContext.language) {
    i18n.changeLanguage(props.pageContext.language)
  }
  const categoriesInfo = pageContext.categoriesInfo
  const country = pageContext.country
  const localisedCountryName = t(country)

  const locale = getValidLocaleCode(
    pageContext.language,
    pageContext.countryDetail.isoCode || "DE"
  )
  const isInternational = country === "International"
  const pricesLastDate = pageContext.deployDate

  let htmlTitle = !isInternational
    ? t(`html_title_page3`)
    : t(`html_title_page1`)
  htmlTitle = htmlTitle.replace("[%1]", localisedCountryName)

  let htmlDescription = !isInternational
    ? t(`html_description_3`)
    : t(`html_description_1`)
  htmlDescription = htmlDescription.replace("[%1]", localisedCountryName)

  return (
    <Layout
      pageContext={props.pageContext}
      pageLocation={props.location}
      theme={"white-bg"}
      html={{
        title: htmlTitle,
        description: htmlDescription,
      }}
    >
      <BreadCrumb
        items={[
          { label: "Home", url: "/" },
          { label: "All_Scrap_Prices", url: "/scrap-metal-price/" },
          { label: !isInternational ? country : "International" },
        ]}
      />
      <MainTitleAndDescription countryName={country} />

      <ScrapMetalPriceIndex
        availableCountries={pageContext.availableCountries}
        allCountries={pageContext.allCountries}
        country={pageContext.country}
        categoriesInfo={categoriesInfo}
        locale={locale}
        currency={pageContext.countryDetail.currency}
        language={pageContext.language}
        hideTitle={true}
      />

      <PriceAlertsBanner
        language={pageContext.language}
        dataEvent={{
          id: "Price alert clicked",
        }}
      />

      <CategoryPrices
        locale={locale}
        countryName={country}
        countryCurrency={pageContext.countryCurrency}
        meanPricesByMaterial={pageContext.meanPricesByMaterial}
        pricesLastDate={pricesLastDate}
        language={pageContext.language}
      />

      <MessageBanner
        dataEvent={{
          id: "Pro Form All",
          triggers: "GetQuote",
          source: "PricePages",
        }}
      />

      <ListOfCountries
        availableCountries={pageContext.availableCountries}
        allCountries={pageContext.allCountries}
        language={pageContext.language}
        materialName={null}
        hideDescription={true}
      />
      <FaqSection />
      {isInternational && (
        <CasesCarrouselSection
          dataEvent={{
            id: "Case Studies All",
            triggers: "ExploreCaseStudies",
            source: "PricePages",
          }}
        />
      )}
      <OperationalExcellence />
      <BuySellBanner
        dataEvents={[
          {
            id: "Contact Form All",
            triggers: "BuyNow",
            source: "PricePages",
          },
          null,
        ]}
      />
    </Layout>
  )
}

export default PriceIndexPage
export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
